// суфікси: від довших до коротших
const SUFFIXES = [
  "уваннями","юваннями","юванням","уванням","юваннях","уваннях","ювання","ування",
  "істями","ністю","остями","остях","остив","ості","ість",
  "еннями","енням","ення","енню","енн",
  "ськими","ського","ській","ським","ський","ська","ські",
  "ивими","овими","евими","ими","іми","ому","ого","ими","их","ій","ий",
  "цями","цях","цям","цю","ця","ці","ць",
  "ями","ами","еві","ові","ики","ях","ам","ах","ою","ею","єю","ем",
  "ся","сь","ти","те","ли","ла","ло","ли",
  "у","ю","а","я","е","є","і","ї","о","и",
];

export function stem(token) {
  if (!token) return "";

  // нормалізація апострофа/регістру
  let t = String(token).toLowerCase().replace(/[\u2019\u2018\u2032']/g, "’");

  // один прохід по суфіксах
  for (const sfx of SUFFIXES) {
    if (t.length > 3 && t.endsWith(sfx)) {
      t = t.slice(0, -sfx.length);
      break;
    }
  }

  // фінальний м’який знак
  if (t.length > 3 && t.endsWith("ь")) t = t.slice(0, -1);

  // інтенції
  t = t.replace(/^купл?/, "куп");
  t = t.replace(/^прод(а|у|а?ж)/, "прод");
  t = t.replace(/^оренд(ув|у|а)?/, "оренд");
  t = t.replace(/^(зн(я|і)м|зйм)/, "знім");
  t = t.replace(/^зда(ю|ється|ча)?/, "здам");
  t = t.replace(/^(обміня|поміня|міня)/, "обмін");
  t = t.replace(/^безкоштовн.*/, "безкоштовн");

  // професії/послуги
  t = t.replace(/^психотерап.*/, "психотерап");
  t = t.replace(/^психолог.*/, "психолог");
  t = t.replace(/^юрист.*/, "юрист");
  t = t.replace(/^адвокат.*/, "адвокат");
  t = t.replace(/^нотаріус.*/, "нотаріус");
  t = t.replace(/^манікюр.*/, "манікюр");
  t = t.replace(/^педикюр.*/, "педикюр");
  t = t.replace(/^візаж.*/, "візаж");
  t = t.replace(/^перукар.*/, "перукар");
  t = t.replace(/^плиточ.*/, "плиточн");
  t = t.replace(/^електрик.*/, "електрик");
  t = t.replace(/^сантехнік.*/, "сантехнік");
  t = t.replace(/^масажист.*/, "масажист");
  t = t.replace(/^дизайн.*/, "дизайн");
  t = t.replace(/^репетитор.*/, "репетитор");
  t = t.replace(/^фотограф.*/, "фотограф");
  t = t.replace(/^відеограф.*/, "відеограф");
  t = t.replace(/^барбер.*/, "барбер");
  t = t.replace(/^колорист.*/, "колорист");
  t = t.replace(/^(смм|smm).*/, "smm");
  t = t.replace(/^маркетолог.*/, "маркетолог");
  t = t.replace(/^копірайтер.*/, "копірайтер");
  t = t.replace(/^програміст.*/, "програміст");
  t = t.replace(/^розробник.*/, "розробник");

  // предметні корені
  t = t.replace(/^косметик.*/, "космет");
  t = t.replace(/^телефон.*/, "телефон");
  t = t.replace(/^ноутбук.*/, "ноутбук");
  t = t.replace(/^велосипед.*/, "велосипед");

  return t;
}
